import { inject, Injectable } from '@angular/core';
import { IncomingEventsReceiverService } from './incoming-events/incoming-events-receiver.service';

@Injectable({ providedIn: 'root' })
export class IncomingEventsHandlerService {
  private readonly receiver = inject(IncomingEventsReceiverService);

  public register(): void {
    this.receiver.register();
  }
}
